import { render, staticRenderFns } from "./NewEmployer.vue?vue&type=template&id=77b474fa&"
import script from "./NewEmployer.vue?vue&type=script&lang=js&"
export * from "./NewEmployer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports